export default __webpack_public_path__ + "static/media/MyPhoto.86553d90.jpg";